import { Component, OnInit, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { NewPrintMediaBodyComponent } from "./new-print-media-body/new-print-media-body.component";
import { goBackToHistory } from "../utils/history-navigation-utils";

@Component({
  selector: "app-new-print-media",
  templateUrl: "./new-print-media.component.html",
  styleUrls: ["./new-print-media.component.scss"],
})
export class NewPrintMediaComponent implements OnInit {
  @ViewChild(NewPrintMediaBodyComponent)
  printBodyComponent: NewPrintMediaBodyComponent;
  isHistoryView = false;

  constructor(private location: Location) {}

  ngOnInit(): void {
    this.isHistoryView = !!localStorage.getItem("mediaReportHistoryData");
  }

  goBack() {
    if (sessionStorage.getItem("historyDetailFromHistory") === "true") {
      goBackToHistory(this.location);
      return;
    }
    localStorage.setItem("skipSearchOnBack", "true");
    localStorage.setItem("skipSearchOnBackTs", Date.now().toString());
    this.location.back();
  }

  savePageRecord() {
    if (this.printBodyComponent) {
      this.printBodyComponent.saveRecord();
    }
  }
}
